import { groupAgentsByAgency } from './group-agents-by-agency';
export function agentRowKey(agent) {
    return agent.rowKey;
}
function moverSectionRows(direction, rows, title, emptyMessage) {
    const result = [
        {
            type: 'section-header',
            key: `section-${direction}`,
            title: `${title} (${rows.length})`,
        },
    ];
    if (rows.length === 0) {
        result.push({ type: 'empty', key: `empty-${direction}`, message: emptyMessage });
        return result;
    }
    for (const row of rows) {
        result.push({
            type: 'agent',
            key: `mover-${direction}-${agentRowKey(row.agent)}-${row.from.quantityStageOrder}-${row.from.yBucket}-${row.to.quantityStageOrder}-${row.to.yBucket}`,
            agent: row.agent,
            mover: row,
        });
    }
    return result;
}
export function buildFunnelListRows(agents, moverGroups) {
    if (moverGroups) {
        return [
            ...moverSectionRows('in', moverGroups.in, 'Пришли', 'Никто не пришёл в эту клетку.'),
            ...moverSectionRows('out', moverGroups.out, 'Ушли', 'Никто не ушёл из этой клетки.'),
        ];
    }
    if (agents.length === 0) {
        return [{ type: 'empty', key: 'empty', message: 'Нет агентов.' }];
    }
    const rows = [];
    for (const group of groupAgentsByAgency(agents)) {
        rows.push({
            type: 'agency-header',
            key: `agency-${group.agencyName}`,
            agencyName: group.agencyName,
        });
        for (const agent of group.agents) {
            rows.push({
                type: 'agent',
                key: `agent-${agentRowKey(agent)}`,
                agent,
            });
        }
    }
    return rows;
}
export function buildFunnelAgentCardHref(lkAgentId, reportHref) {
    return `/agents/${lkAgentId}?from=${encodeURIComponent(reportHref)}`;
}
export function cellSelectionFromPoint(point, yBucketMax) {
    return {
        kind: 'cell',
        quantityStageOrder: point.quantityStageOrder,
        yBucket: Math.min(point.yBucket, yBucketMax),
    };
}
